import React from "react";
import yellowIndicator from "@src/assets/svg/yellow-indicator-icon.svg";
import { OTAInstallActionButton } from "@src/components/atoms/ota-install-action-button/ota-install-action-button";
import styles from "./ota-request-for-approval.module.scss";
import { useOtaRequestForApproval } from "./use-ota-request-for-approval";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
interface OTARequestForApprovalProps {
  activeInstallationData?: ActiveInstallationProcessPayload | null;
}
const cssClassName = "ota-request-for-approval";

export default function OTARequestForApproval({
  activeInstallationData,
}: OTARequestForApprovalProps) {
  const { texts, descriptionText, showContent, handleReviewRequestAndApprove } =
    useOtaRequestForApproval({ activeInstallationData });

  if (!showContent) return null;

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={yellowIndicator}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>
            {texts.titleHasItemName ? (
              <>
                {texts.titlePrefix}
                <span
                  className={styles[`${cssClassName}__title-item-name`]}
                  title={texts.itemName}
                >
                  {texts.itemName}
                </span>
                {texts.titleSuffix}
              </>
            ) : (
              texts.title
            )}
          </span>
          <span className={styles[`${cssClassName}__description`]}>
            {descriptionText}
          </span>
        </div>
      </div>

      <OTAInstallActionButton
        text={texts.reviewAndApproveButtonText}
        variant="primary"
        fun={handleReviewRequestAndApprove}
      />
    </div>
  );
}
